import { useState } from "react";

export const Quiz = () => {
  const questions = [
    {
      question:
        "What regular-serviced sites should you hesitate to book people on if they have a dining tent, and their camping unit is within 6 feet of the maximum for the site? (either warn them and confirm they know it will be tight / might not fit the dining tent, or book them on a different site)",
      answers: ["6", "7", "41", "50", "54", "73", "76", "A", "H", "M"],
    },
    {
      question:
        "What premium-serviced sites should you hesitate to book people on if they have a dining tent, and their camping unit is within 6 feet of the maximum for the site? (either warn them and confirm they know it will be tight / might not fit the dining tent, or book them on a different site)",
      answers: ["65", "66", "E", "F"],
    },
  ];

  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [input, setInput] = useState("");
  const [guessed, setGuessed] = useState([]);

  const currentQuestion = questions[currentQuestionIndex];

  const handleChange = (e) => {
    const value = e.target.value.replace(/\s/g, "").toUpperCase();
    setInput(value);

    const normalized = value.trim();

    if (
      currentQuestion.answers.includes(normalized) &&
      !guessed.includes(normalized)
    ) {
      setGuessed((prev) => [...prev, normalized]);
      setInput("");
    }
  };

  const handleNextQuestion = () => {
    setCurrentQuestionIndex((prev) => prev + 1);
    setGuessed([]);
    setInput("");
  };

  return (
    <div className="page">
      <h4>
        Question {currentQuestionIndex + 1} / {questions.length}
      </h4>

      <h2>{currentQuestion.question}</h2>

      <h3>
        {guessed.length} / {currentQuestion.answers.length} correct
      </h3>

      {guessed.length === currentQuestion.answers.length && (
        <h3 style={{ color: "green", marginTop: "10px" }}>
          Perfect score ({currentQuestion.answers.length} /{" "}
          {currentQuestion.answers.length}) 🎉
        </h3>
      )}

      {guessed.length !== currentQuestion.answers.length && (
        <input
          type="text"
          value={input}
          onChange={handleChange}
          placeholder="Enter a site..."
          maxLength={2}
          autoFocus
        />
      )}
      {guessed.length === currentQuestion.answers.length &&
        currentQuestionIndex < questions.length - 1 && (
          <button onClick={handleNextQuestion} style={{ marginTop: "20px" }}>
            Next Question
          </button>
        )}

      <div style={{ marginTop: "20px" }}>
        <h4>Correct Answers:</h4>
        <ul>
          {[...guessed]
            .sort((a, b) => {
              const isNumA = !isNaN(a);
              const isNumB = !isNaN(b);

              if (isNumA && isNumB) return Number(a) - Number(b);
              if (isNumA) return -1;
              if (isNumB) return 1;

              return a.localeCompare(b);
            })
            .map((ans) => (
              <li key={ans}>{ans}</li>
            ))}
        </ul>
      </div>
    </div>
  );
};
